import BgVideo from '../../assets/vedio/ideasvedio.mp4';
import './main.css'
import { Link } from "react-router-dom";

function Hero() {
  return (
    <section className='HeroSecton height-section'>
    <div className='BGvideo'>
      <video autoPlay muted loop playsInline preload='auto' poster='/ideas-video-poster.webp' className='video-bg'>
        <source src={BgVideo} type='video/mp4' />
      
      </video>
      <div className='container BgVedioContainer'>
        <div className='row d-flex justify-content-center align-item-center'>
          <div className='Heading col'>
            <h1>Setting Global Standards</h1>
          </div>
          <div className='SubHeading col'>
            
            <p>We ideate, engineer, and execute <br /> power solutions for our clients</p>
            <Link to='/about' className='btn'>
              Learn More
            </Link>
          </div>
        </div>
      </div>
    </div>
    </section>
  );
}

export default Hero;
